/**
 * register plugins
 */
import scan from "rfuncs/functions/scan"

import append from "./append"

export default <K extends keyof HTMLElementTagNameMap>(
  t: K,
  attrs: Record<string, string> = {},
  inner: any = null
): HTMLElementTagNameMap[K] => {
  let element = document.createElement(t)
  scan((v, k) => element.setAttribute(k, v), attrs)
  append(element, inner)
  return element
}
